<div
  class="position-relative"
  [ngClass]="{ 'is-active': patientSearchedList.length > 0 || patientNotFound }"
  >
  <input
    class="form-control"
    placeholder="Search Patient..."
    type="search"
    #searchInput
    />
    <button class="btn ps-0">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enable-background="new 0 0 24 24"
        viewBox="0 0 24 24"
        >
        <path
          d="M21.2529297,17.6464844l-2.8994141-2.8994141c-0.0021973-0.0021973-0.0043945-0.0043945-0.0065918-0.0065918c-0.8752441-0.8721313-2.2249146-0.9760132-3.2143555-0.3148804l-0.8467407-0.8467407c1.0981445-1.2668457,1.7143555-2.887146,1.715332-4.5747681c0.0021973-3.8643799-3.1286621-6.9989014-6.993042-7.0011597S2.0092773,5.1315308,2.007019,8.9959106S5.1356201,15.994812,9,15.9970703c1.6889038,0.0029907,3.3114014-0.6120605,4.5789185-1.7111206l0.84729,0.84729c-0.6630859,0.9924316-0.5566406,2.3459473,0.3208618,3.2202759l2.8994141,2.8994141c0.4780884,0.4786987,1.1271973,0.7471313,1.8037109,0.7460938c0.6766357,0.0001831,1.3256226-0.2686768,1.803894-0.7472534C22.2493286,20.2558594,22.2488403,18.6417236,21.2529297,17.6464844z M9.0084229,14.9970703c-3.3120728,0.0023193-5.9989624-2.6807861-6.0012817-5.9928589S5.6879272,3.005249,9,3.0029297c1.5910034-0.0026855,3.1175537,0.628479,4.2421875,1.7539062c1.1252441,1.1238403,1.7579956,2.6486206,1.7590942,4.2389526C15.0036011,12.3078613,12.3204956,14.994751,9.0084229,14.9970703z M20.5458984,20.5413818c-0.604126,0.6066284-1.5856934,0.6087036-2.1923828,0.0045166l-2.8994141-2.8994141c-0.2913818-0.2910156-0.4549561-0.6861572-0.4544678-1.0979614C15.0006714,15.6928101,15.6951294,15,16.5507812,15.0009766c0.4109497-0.0005493,0.8051758,0.1624756,1.0957031,0.453125l2.8994141,2.8994141C21.1482544,18.9584351,21.1482544,19.9364624,20.5458984,20.5413818z"
          />
        </svg>
      </button>
    </div>
    <div id="ui-autocomplete">
      @if (patientNotFound) {
        <div class="search-results">
          <div class="alert alert-danger d-flex m-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
              viewBox="0 0 16 16"
              role="img"
              aria-label="Warning:"
              >
              <use xlink:href="#exclamation-triangle-fill"></use>
            </svg>
            <div>{{message.noPatientFound}}</div>
          </div>
        </div>
      }
      @if (visibleDropdown) {
        <div [ngClass]="{ 'search-results': patientSearchedList.length > 0 }"
          #patientSearchList>
          @for (patient of patientSearchedList; track patient) {
            <div
              class="search-results__item"
              (click)="patientSelectHandler(patient)"
              >
              <div class="flex-fill">{{ patient.name }}</div>
              <div>{{ patient.enrollmentNo }}</div>
            </div>
          }
        </div>
      }
    </div>
